export class Session {
  static setOrgId(orgId: string) {
    sessionStorage.setItem("user-org-id", orgId);
  }

  static setOrgName(orgName: string) {
    sessionStorage.setItem("user-org-name", orgName);
  }

  static getOrgId(): string {
    return sessionStorage.getItem("user-org-id") || "";
  }

  static removeOrgId() {
    sessionStorage.removeItem("user-org-id");
    sessionStorage.removeItem("user-org-name");
  }
}
